export class ContextMenu {
    public ID: number
    public DisplayText: string;
    public Key: string;
    public Icon:string;
    public Hidden: boolean;
    public Pinned: boolean;
}